export class VersionCheckService {
  constructor ($http, API) {
    'ngInject';

    this.$http = $http;
    this.API = API;
  }

  getIndexHtml() {
    return this.$http({
      method: 'GET',
      url: window.location.origin,
      params: {
        cacheBuster: Math.random().toString().slice(2,10)
      },
      timeout: 5000
    });
  }
}
